import React from "react";
import PropTypes from "prop-types";

import { evalHelper } from "../../utils";

class GlobalChangeMapChart extends React.Component {
  componentDidMount() {
    if (!this.props.dataAndOptions) { return; }

    this.mutateDom();
  }

  componentDidUpdate() {
    if (!this.props.dataAndOptions) { return; }
    this.removeMap();

    this.mutateDom();
  }

  mutateDom() {
    window.leafletBuilder(this.mapHtmlId, 0, this.data);
  }

  componentWillUnmount() {
    this.removeMap();
  }

  removeMap() {
    if (window.tariffMap) {
      window.tariffMap.removeProperly();
      window.tariffMap = null;
    }
  }

  render() {
    if (!this.props.dataAndOptions) { return <div></div>; }

    const chartDataAndOptions = evalHelper(this.props.dataAndOptions).chart;

    this.data = chartDataAndOptions.chart_data;
    this.data.selectedCountry = this.props.selectedCountry;
    this.data.selectCountryInMap = this.props.onChange;

    const options = evalHelper(chartDataAndOptions.options);
    this.mapHtmlId = options.html_id;

    return (
      <div className="visualization-wrapper">
        <h3 style={{ textAlign: "center", fontSize: "18px" }}>{this.props.title}</h3>
        <div className="leaflet-map-container" id={this.mapHtmlId}></div>
      </div>
    );
  }
}

GlobalChangeMapChart.propTypes = {
  dataAndOptions: PropTypes.string,
  title: PropTypes.string,
  selectedCountry: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default GlobalChangeMapChart;
